import { FaGithub, FaLinkedinIn, FaInstagram, FaFacebookF } from "react-icons/fa";
import { Magnetic } from "./ui/motion";
import { Panel } from "../journey/Panel";

const SOCIALS = [
  { icon: <FaInstagram />, url: "https://www.instagram.com/tsak.__/" },
  { icon: <FaFacebookF />, url: "https://www.facebook.com/nicktsiakiris/" },
  { icon: <FaGithub />, url: "https://github.com/ntsiakiris" },
  {
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/in/nikolaos-tsiakiris-b047a2229/",
  },
];

function BackToTop() {
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-cursor-label="top"
      className="group flex items-center gap-2 text-paper hover:text-acid transition-colors w-fit"
    >
      <span className="font-mono text-xs uppercase tracking-[0.2em]">Back to top</span>
      <span className="transition-transform duration-300 group-hover:-translate-y-1">↑</span>
    </button>
  );
}

function SocialRow() {
  return (
    <div className="flex items-center gap-3">
      {SOCIALS.map((s, i) => (
        <Magnetic key={i} strength={0.4}>
          <a
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 grid place-items-center rounded-full border border-paper/20 text-paper hover:bg-acid hover:text-ink hover:border-acid transition-colors duration-300"
          >
            {s.icon}
          </a>
        </Magnetic>
      ))}
    </div>
  );
}

function LegalRow() {
  return (
    <div className="mt-12 pt-6 border-t border-paper/10 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] uppercase tracking-[0.15em] text-paper-dim">
      <span>© 2024–2026 — All rights reserved</span>
      <span>Built with React · Framer Motion · Tailwind</span>
    </div>
  );
}

export default function Footer({ horizontal }) {
  if (horizontal) {
    return (
      <section id="outro" className="flex h-full shrink-0">
        <Panel horizontal className="flex flex-col justify-center px-6 sm:px-10">
          {/* big wordmark — the closing shot */}
          <h2 className="display text-[13vw] leading-none text-stroke select-none mb-12">
            Tsiakiris<span className="text-acid not-italic">.</span>
          </h2>

          <div className="flex flex-col mdl:flex-row items-start mdl:items-end justify-between gap-10">
            <div className="flex flex-col gap-3">
              <span className="eyebrow">Tsiakiris Nikos — Front-End Engineer</span>
              <BackToTop />
            </div>
            <SocialRow />
          </div>

          <LegalRow />
        </Panel>
      </section>
    );
  }

  return (
    <footer id="outro" className="relative px-6 sm:px-10 pt-20 pb-10 border-t border-paper/10">
      {/* big wordmark */}
      <h2 className="display text-[16vw] leading-none text-stroke select-none mb-12">
        Tsiakiris<span className="text-acid not-italic">.</span>
      </h2>

      <div className="flex flex-col mdl:flex-row items-start mdl:items-end justify-between gap-10">
        <div className="flex flex-col gap-3">
          <span className="eyebrow">Tsiakiris Nikos — Front-End Engineer</span>
          <BackToTop />
        </div>
        <SocialRow />
      </div>

      <LegalRow />
    </footer>
  );
}
